import React from 'react';

const MyHistry = () => {
    return (
        <div>
            <h2>hlw from history</h2>
        </div>
    );
};

export default MyHistry;